import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Chip } from '@fe-learner-common';

export type FilterChip = {
  value: string;
  label: string;
  group: {
    key: string;
    label: string;
  };
};
type FilterChipsProps = {
  chips?: FilterChip[];
  nrOfResults: number;
  onRemoveFilter: (groupKey: string, filterKey: string) => void;
  onClearAll: () => void;
};

export const FilterChips: FC<FilterChipsProps> = ({
  chips,
  nrOfResults,
  onRemoveFilter,
  onClearAll,
}) => {
  const intl = useIntl();
  if (!chips?.length) return null;

  const handleRemove = (groupKey: string, filterKey: string) => {
    onRemoveFilter(groupKey, filterKey);
  };

  return (
    <div className="flex  items-start gap-3 border-b-1 border-solid border-neutral-100 p-5">
      <p className="sr-only" aria-atomic aria-live="polite">
        {intl.formatMessage(
          { id: 'learner.common.filter.sr.filtersApplied' },
          {
            nr: chips?.length,
          },
        )}
        {intl.formatMessage(
          { id: 'learner.common.filter.sr.results' },
          {
            nr: nrOfResults,
          },
        )}
      </p>

      <ul className="flex flex-wrap gap-2">
        {chips?.map((chip) => {
          if (!chip) return null;

          return (
            <li key={`chip-${chip.group}-${chip.value}`}>
              <Chip
                aria-describedby="remove-filter-description"
                label={`${chip.group.label}: ${chip.label}`}
                className="first-letter:capitalize"
                onRemove={() => handleRemove(chip.group.key, chip.value)}
              />
            </li>
          );
        })}
      </ul>
      <p className="sr-only" id="remove-filter-description">
        {intl.formatMessage({ id: 'learner.common.filter.sr.removeFilter' })}
      </p>
      <button className="l-btn l-btn-sm l-btn-tertiary" onClick={onClearAll}>
        {intl.formatMessage({ id: 'learner.common.filter.reset' })}
      </button>
    </div>
  );
};
